import { render, staticRenderFns } from "./WordsLoader.vue?vue&type=template&id=33f9bf8a&scoped=true"
import script from "./WordsLoader.vue?vue&type=script&lang=js"
export * from "./WordsLoader.vue?vue&type=script&lang=js"
import style0 from "./WordsLoader.vue?vue&type=style&index=0&id=33f9bf8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9bf8a",
  null
  
)

export default component.exports